import { splitByNewlines } from '@disco/utils/newlines'
import * as React from 'react'
export const convertBreakCharsToLineBreaks = (
  text: string,
): React.ReactNode[] =>
  splitByNewlines(text).map((line, i) => (
    <React.Fragment key={i}>
      {line}
      <br />
    </React.Fragment>
  ))
export function newlines(text: string): React.ReactNode[] {
  return splitByNewlines(text).map((line, idx) =>
    line ? <div key={idx}>{line}</div> : <br key={idx} />,
  )
}
